<template>
  <div class="container mt-4">
    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2 p-1 ">
      <h2 class="mb-0 main-title">Materials</h2>
      <div class="d-flex align-items-center gap-2">
        <button class="btn btn-md btn-primary fs-11 fw-normal hover-white" @click="openCreateModal('createModal')">
          <i class="fa fa-plus fs-11"></i> Add New Material
        </button>

        <button class="btn btn-md btn-outline-secondary hover-white fs-11 fw-normal"
          @click="$router.push({ name: 'MaterialImport' })">
          <i class="fa fa-upload fs-11"></i> Import Material
        </button>
      </div>

    </div>
    <!-- Sirf Filters Bar -->
    <div class="filters-wrapper">
      <div class="filters-bar" id="filtersBar"></div>
      <button @click="resetAllFilters" class="btn btn-sm btn-outline-danger hover-white">
        <span class="material-symbols-outlined fs-6">undo</span> Reset
      </button>
    </div>

    <!-- Dropdown Template -->
    <div id="genericFilterDropdownTemplate" style="display: none;">
      <div class="generic-filter-dropdown">
        <div class="dropdown-header">
          <input type="text" class="filter-search-input" placeholder="Search...">
        </div>
        <div class="dropdown-body filter-options-container"></div>
        <div class="dropdown-footer">
          <button class="filter-clear-btn">Clear</button>
          <button class="filter-apply-btn">Apply</button>
        </div>
      </div>
    </div>
    <div class="card p-1 bg-white">
<FormModal ref="createModal" title="Create New Material" id="create_material_form_modal"
  @close="closeCreateModal('createModal')">
  <CreateMaterial ref="CreateMaterialForm" @created="onCreated" />
</FormModal>
      <FormModal v-if="showEditModal" ref="editModal" title="Edit Material" id="edit_material_form_modal">
        <EditMaterial :materialId="editingMaterialId" @created="onCreated" @close="closeEditModal" />
      </FormModal>

      <!-- Loading State -->
      <LoadingBar v-if="loading" message="Loading Materials..." />
      <div v-else class="table-wrapper">
        <ListTable>

          <colgroup>
            <!-- <col style="width: 6%"> -->
            <col style="width: 30%"> <!-- Title -->
            <col style="width: 10%"> <!-- Unit -->
            <col style="width: 12%"> <!-- Manufacturer -->
            <col style="width: 10%"> <!-- QR Code -->
            <col style="width: 10%"> <!-- Category -->
            <col style="width: 12%"> <!-- Assets -->
            <col style="width: 10%"> <!-- Description -->
            <col style="width: 6%"> <!-- Action -->
          </colgroup>

          <thead>
            <tr>
              <!-- <th>SR#</th> -->

              <th @click="sortBy('name')" class="sortable">
                Title <i :class="getSortIcon('name')"></i>
              </th>

              <th @click="sortBy('unit')" class="sortable">
                Unit <i :class="getSortIcon('unit')"></i>
              </th>

              <th @click="sortBy('manufacturer')" class="sortable">
                Manufacturer <i :class="getSortIcon('manufacturer')"></i>
              </th>

              <th @click="sortBy('code')" class="sortable">
                QR Code <i :class="getSortIcon('code')"></i>
              </th>

              <th>Category</th>

              <th>Assets</th>

              <th @click="sortBy('description')" class="sortable">
                Description <i :class="getSortIcon('description')"></i>
              </th>

              <th class="text-center">Action</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="material in materials" :key="material.external_id">

              <!-- SR# -->
              <!-- <td>
                
                  {{ index + 1 }}
              </td> -->

              <!-- TITLE -->
              <td class="align-middle">
                <div class="d-flex align-items-center gap-2" style="cursor: pointer;"
                  @click="viewDetails(material.external_id)">

                  <div
                    class="d-flex align-items-center justify-content-center bg-primary-subtle border border-primary-subtle rounded-3"
                    style="width: 40px; height: 40px; min-width: 40px;">

                    <span v-if="material.get_category && material.get_category.name === 'Parts'"
                      class="material-symbols-outlined text-primary fs-10">
                      precision_manufacturing
                    </span>

                    <span v-else class="material-symbols-outlined text-primary fs-10">
                      science
                    </span>
                  </div>

                  <div>
                    <div class="mb-0 text-dark">
                      {{ material.name }}
                    </div>

                    <div class="mt-0">
                      <small class="text-muted">
                        #{{ material.serial_number }}
                      </small>
                    </div>
                  </div>

                </div>
              </td>

              <td>
                {{ material.quantity || 0 }} {{ material.unit }}
              </td>

              <td>
                {{ material.manufacturer }}
              </td>

              <td>
                {{ material.code }}
              </td>

              <td>
                <span v-if="material.get_category" class="badge bg-primary">
                  {{ material.get_category.name }}
                </span>

                <span v-else class="badge bg-secondary">
                  No Category
                </span>
              </td>

              <td>
                <AssetsDropdown :items="material.get_assets" label="Assets" serial-key="external_id" icon="cube"
                  row-icon="cube" />
              </td>

              <td>
                {{ material.description || '-' }}
              </td>

              <td class="text-center">
                <TableActionDropdown>
                  <li>
                    <a class="dropdown-item" @click.prevent="viewDetails(material.external_id)">
                      <i class="fa fa-eye text-info"></i>
                      <span>Profile</span>
                    </a>
                  </li>

                  <li>
                    <a class="dropdown-item" @click.prevent="edit(material)">
                      <i class="fa fa-pencil text-primary"></i>
                      <span>Edit</span>
                    </a>
                  </li>
                  <hr class="dropdown-divider" />

                  <li>
                    <a class="dropdown-item item-danger" @click.prevent="deleteMaterial(material)">
                      <i class="fa fa-trash"></i>
                      <span>Delete</span>
                    </a>
                  </li>
                </TableActionDropdown>
              </td>

            </tr>

            <tr v-if="materials.length === 0">
              <td colspan="9" class="text-center">
                No Materials Found
              </td>
            </tr>

          </tbody>
        </ListTable>
      </div>
      <!-- Pagination -->
      <Pagination :pagination="pagination" @page-change="changePage" />

    </div>
  </div>
  <ConfirmDeleteModal
  v-model="showDeleteModal"
  title="Delete Material"
  :item-name="deletingMaterial?.name"
  :loading="deleting"
  @confirm="confirmDelete"
/>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'
import Pagination from '@/components/utils/PaginationBar.vue'
import LoadingBar from '@/components/utils/LoadingBar.vue'
import FormModal from '@/components/utils/FormModal.vue'
import CreateMaterial from '@/views/Materials/CreateMaterial.vue'
import ListTable from '@/components/utils/ListTable.vue'
import TableActionDropdown from '@/components/TableActionDropdown.vue'
import EditMaterial from '@/views/Materials/EditMaterial.vue'
import AssetsDropdown from '@/components/AttributesDropdown.vue'
import ConfirmDeleteModal from '@/components/utils/ConfirmDeleteModal.vue'
export default {
  name: 'materialList',
  components: {
    Pagination,
    LoadingBar,
    FormModal,
    CreateMaterial,
    ListTable,
    TableActionDropdown,
    EditMaterial,
    AssetsDropdown,
     ConfirmDeleteModal
  },
  data() {
    return {
      materials: [],
      categories: [],
      assets: [],
      pagination: {
        total_rows: 0,
        per_page: 20,
        current_page: 1,
        total_pages: 1
      },
      loading: false,
      filterManager: null,
      sortColumn: null,
      sortOrder: 'asc',
      filteredData: [],
      currentFilters: {},
      editingMaterialId: null,
      showEditModal: false,
       showDeleteModal: false,
      deletingMaterial:    null,
      deleting:        false,
    }
  },
  computed: {

    // Sorted data
    sortedData() {
      let result = [...this.filteredData];

      if (this.sortColumn) {
        result.sort((a, b) => {
          let valA = a[this.sortColumn];
          let valB = b[this.sortColumn];

          if (valA === undefined || valA === null) valA = '';
          if (valB === undefined || valB === null) valB = '';

          if (this.sortColumn === 'id') {
            valA = parseInt(String(valA).replace('#', '')) || 0;
            valB = parseInt(String(valB).replace('#', '')) || 0;
          }

          if (typeof valA === 'string') valA = valA.toLowerCase();
          if (typeof valB === 'string') valB = valB.toLowerCase();

          if (valA < valB) return this.sortOrder === 'asc' ? -1 : 1;
          if (valA > valB) return this.sortOrder === 'asc' ? 1 : -1;
          return 0;
        });
      }

      return result;
    },
  },
  mounted() { //doc read
    this.fetchList();
    Promise.all([this.fetchCategories(), this.fetchAssets()])
      .then(() => {
        this.initFilters();
      });
    // .finally(() => {
    //   this.fetchList();
    // });
  },
  methods: {
    openCreateModal(ref) {
      this.$refs[ref].showModal()

    },

    closeCreateModal(ref) {
      const modal = this.$refs[ref]
      if (modal && modal.isVisible) {
        modal.closeModal()
      }
    },

    async onCreated() {
      this.pagination.current_page = 1
      await this.fetchList()
    },

    async fetchList() {
      this.loading = true

      const result = await form_api_submit({
        url: 'materials/list',
        method: 'GET',
        data: {
          page: this.pagination.current_page,
          ...this.currentFilters
        },
        show_success_toast: false,
        show_error_toast: true,
        remove_pre_toasts: false
      })

      if (result.success) {
        // console.log(result.data.list);

        result.data.list.forEach((item, index) => {
          console.log(index, {
            category: item.get_category,
            assets: item.get_assets
          });

        });
        this.materials = result.data.list.map(m => ({ ...m, _dropdownOpen: false }));
        this.filteredData = [...this.materials];
      }

      this.loading = false
    },

    async fetchCategories() {
      const result = await form_api_submit({
        url: 'material-categories/dropdown',
        method: 'GET',
        data: {},
        show_success_toast: false,
        show_error_toast: true,
        remove_pre_toasts: false
      })

      if (result.success) {
        this.categories = result.data.list || result.data || []
      }
    },

    async fetchAssets() {
      const result = await form_api_submit({
        url: 'asset/dropdown',
        method: 'GET',
        data: {},
        show_success_toast: false,
        show_error_toast: true,
        remove_pre_toasts: false
      })

      if (result.success) {
        this.assets = result.data.list || result.data || []
      }
    },

    changePage(page) {
      if (page < 1 || page > this.pagination.total_pages) return
      this.pagination.current_page = page
      // alert(this.pagination.current_page);
      this.fetchList()
    },
    initFilters() {
      if (typeof $ === "undefined" || typeof GenericFilterManager === "undefined") return;

      const categoryOptions = (this.categories || []).map(category => ({
        value: String(category.id),
        label: category.name
      }));

      const assetOptions = (this.assets || []).map(asset => ({
        value: String(asset.id),
        label: asset.name
      }));

      this.filterManager = new GenericFilterManager({
        containerId: "filtersBar",
        filters: [
          {
            key: "id",
            label: "ID",
            type: "input",
            placeholder: "Filter by ID"
          },
          {
            key: "name",
            label: "Name",
            type: "input",
            placeholder: "Filter by Name"
          },
          {
            key: "category",
            label: "Category",
            type: "checkbox",
            options: categoryOptions
          },
          {
            key: "assets",
            label: "Assets",
            type: "checkbox",
            options: assetOptions
          }
        ],
        onFilterChange: (filters) => {
          this.applyFilters(filters);
        }
      });
    },

    applyFilters(activeFilters) {
      this.currentFilters = { ...activeFilters };
      this.pagination.current_page = 1;
      this.fetchList();
    },
    resetPagination() {
      this.pagination.current_page = 1;
      this.fetchList();
    },
    resetAllFilters() {
      if (this.filterManager) {
        this.filterManager.clearAllFilters();
      }
      this.currentFilters = {};
      this.sortColumn = null;
      this.sortOrder = 'asc';
      this.pagination.current_page = 1;
      this.fetchList();
    },
    // Sorting method
    sortBy(column) {
      if (this.sortColumn === column) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortOrder = 'asc';
      }
      this.resetPagination();
    },

    getSortIcon(column) {
      if (this.sortColumn !== column) {
        return 'fas fa-sort text-muted';
      }
      return this.sortOrder === 'asc' ? 'fas fa-sort-up text-primary' : 'fas fa-sort-down text-primary';
    },
    edit(material) {
      this.editingMaterialId = material.id
      this.showEditModal = true
      this.$nextTick(() => {
        this.$refs.editModal.showModal()
      })
    },
    closeEditModal(ref) {
      if (this.$refs[ref]) {
        this.$refs[ref].closeModal()
      }

      this.editingMaterialId = null
      this.showEditModal = false
    },
    viewDetails(external_id) {
      console.log('Material external_id:', external_id);

      this.$router.push({
        name: 'MaterialProfile',
        params: {
          external_id
        }
      });
    },
    toggleAssetDropdown(material) {
      const isOpen = material._dropdownOpen;
      this.materials.forEach(m => (m._dropdownOpen = false));
      material._dropdownOpen = !isOpen;
    },
       deleteMaterial(material) {
      this.deletingMaterial = material
      this.showDeleteModal = true
    },

    async confirmDelete() {
      this.deleting = true
      try {
        const result = await form_api_submit({
          url: `materials/delete/${this.deletingMaterial.id}`,
          method: 'POST',
          show_success_toast: true,
          show_error_toast: true,
        })
        if (result.success) {
          this.showDeleteModal = false
          this.deletingMaterial = null
          this.fetchList()
        }
      } finally {
        this.deleting = false
      }
    },

  }
}

</script>
